import { render, staticRenderFns } from "./createCustomRouteCourses.vue?vue&type=template&id=21f840e0&scoped=true"
import script from "./createCustomRouteCourses.vue?vue&type=script&lang=js"
export * from "./createCustomRouteCourses.vue?vue&type=script&lang=js"
import style0 from "./createCustomRouteCourses.vue?vue&type=style&index=0&id=21f840e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f840e0",
  null
  
)

export default component.exports